module.exports = __webpack_public_path__ + "img/live-banner.460140dd.png";